// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: 10px;
  overflow: hidden;
}
@media (orientation: landscape) {
  .banner-wrapper {
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
}
.banner-wrapper .banner-image-container {
  height: calc((100vw - 1rem) / 2.34);
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  overflow: hidden;
}
.banner-wrapper .banner-image-container img {
  height: auto;
  width: 100%;
  border-radius: 10px;
}
@media screen and (min-width: 751px) and (max-width: 1080px) {
  .banner-wrapper .banner-image-container {
    height: calc((100vw - 1rem) / 2.7);
  }
}
@media screen and (min-width: 1081px) {
  .banner-wrapper .banner-image-container {
    height: calc((100vw - 1rem) / 4.75);
  }
}
.banner-wrapper .banner-slider {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.6rem;
}
.banner-wrapper .banner-slider .dot {
  border-radius: 10px;
  background-color: #D7E7F3;
  border: 4px solid #D7E7F3;
}
.banner-wrapper .banner-slider .highlighted {
  border-radius: 10px;
  border: 4px solid var(--ion-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/banner/banner.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EAVF;IAWI,uCAAA;IACA,yCAAA;EAEF;AACF;AAAE;EACE,mCAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EAOA,gBAAA;AAJJ;AAFI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AAIN;AACI;EAbF;IAcI,kCAAA;EAEJ;AACF;AAAI;EAjBF;IAkBI,mCAAA;EAGJ;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAEJ;AADI;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;AAGN;AADI;EACE,mBAAA;EACA,4CAAA;AAGN","sourcesContent":[".banner-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.5rem;\n  border-radius: 10px;\n  overflow: hidden;\n\n  @media (orientation: landscape) {\n    padding-left: env(safe-area-inset-left);\n    padding-right: env(safe-area-inset-right);\n  }\n\n  .banner-image-container {\n    height: calc((100vw - 1rem) / 2.34); // Subtracting margin from both sides because of 0.5rem padding\n    width: 100%;\n    border-radius: 10px;\n    overflow: hidden;\n    img {\n      height: auto;\n      width: 100%;\n      border-radius: 10px;\n    }\n    \n    overflow: hidden;\n \n    @media screen and (min-width: 751px) and (max-width: 1080px) {\n      height: calc((100vw - 1rem) / 2.7);\n    }\n\n    @media screen and (min-width: 1081px) {\n      height: calc((100vw - 1rem) / 4.75);\n    }\n  }\n\n  .banner-slider {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 0.6rem;\n    .dot {\n      border-radius: 10px;\n      background-color: #D7E7F3;\n      border: 4px solid #D7E7F3;\n    }\n    .highlighted {\n      border-radius: 10px;\n      border: 4px solid var(--ion-color-secondary);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
